'use client';

import { useTranslations } from 'next-intl';
import { useParams, useRouter } from 'next/navigation';

/**
 * Not found page for professional profiles
 * Shown when a professional ID doesn't exist
 */
export default function ProfessionalNotFound() {
  const params = useParams();
  const router = useRouter();
  const locale = (params?.locale as string) || 'en';
  const t = useTranslations('ProfessionalDetail');
  const tCommon = useTranslations('Common');

  return (
    <div className="flex items-center justify-center h-64">
      <div className="text-center">
        <h2 className="text-xl font-semibold text-gray-800 mb-2">{t('professionalNotFound')}</h2>
        <button onClick={() => router.push(`/${locale}/search`)} className="text-primary-600 hover:underline">
          {tCommon('backToSearch')}
        </button>
      </div>
    </div>
  );
}
